import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'
import { isThinRegistrationBaseOutput, ThinRegistrationBaseOutput } from './thin-registration-base-output.model'

export interface ConfirmEmailOTPOutput extends ThinRegistrationBaseOutput, BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  IsOTPVerified: boolean
  // eslint-disable-next-line @typescript-eslint/naming-convention
  AttemptBlockedUntil: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  AvailableAttempts: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isConfirmEmailOTPOutput = (obj: any): obj is ConfirmEmailOTPOutput => {
  const attemptBlockedUntil = 'AttemptBlockedUntil'

  return isThinRegistrationBaseOutput && isBaseOutput(obj) && has(obj, attemptBlockedUntil)
}
